import {getRegionList, getPeopleList} from '../requestapi/commRequest'

export default {
    state:{
        //建筑性质
        point_build_property:[
            {code:'1', name: '彩钢板建筑'},
            {code:'2', name: '厂房库房'},
            {code:'3', name: '仓储物流'},
            {code:'4', name: '批发市场'}
        ],
        //所属区域 所有区
        point_all_duty_region:[
            // {"code": "026d5b10-ff8f-45b3-871d-e5cd40fc63a6","name": "火神庙一区"}
        ],
        //人员信息
        point_duty_people:[
            // {"code": "00abb8ba-8d67-4869-91ea-f8263b4ab4ef","name": "餐饮"}
        ],
    },
    mutations:{
        LoadPointAllDuty(state){            
            getRegionList().then(({data}) => {
                console.log(data, 'LoadPointAllDuty data');
                state.point_all_duty_region = data.data
            }).catch((err) => {
                console.log('LoadPointAllDuty error', err);
            });
        },
        LoadPointDutyPeople(state, code){
            // console.log(code,'code-------');
            if(code && code !== ''){
                getPeopleList({params:{'classify':'responsibility','duty_region_code':code}}).then(({data}) => {
                    console.log(data, 'getPeopleList data');
                    state.point_duty_people = data.data
                }).catch((err) => {
                    console.log('getPeopleList error', err);
                });
            }else{
                getPeopleList({params:{'classify':'responsibility'}}).then(({data}) => {
                    console.log(data, 'getPeopleList data');
                    state.point_duty_people = data.data
                }).catch((err) => {
                    console.log('getPeopleList error', err);
                });
            }            
            
        }
    }
}